"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>FindMyTrips_FindMyTrips
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_TravelBotLogoImage_js_namespaceObject = require("../../TravelBotLogoImage.js");
const VerificationCode_js_namespaceObject = require("../VerificationCode/VerificationCode.js");
var VerificationCode_js_default = /*#__PURE__*/ __webpack_require__.n(VerificationCode_js_namespaceObject);
const OtpContext_js_namespaceObject = require("../../context/OtpContext.js");
const OtpForm_js_namespaceObject = require("../OtpForm/OtpForm.js");
var OtpForm_js_default = /*#__PURE__*/ __webpack_require__.n(OtpForm_js_namespaceObject);
const MessageFooter_js_namespaceObject = require("../MessageFooter/MessageFooter.js");
var MessageFooter_js_default = /*#__PURE__*/ __webpack_require__.n(MessageFooter_js_namespaceObject);
const external_ErrorComponent_js_namespaceObject = require("./ErrorComponent.js");
var external_ErrorComponent_js_default = /*#__PURE__*/ __webpack_require__.n(external_ErrorComponent_js_namespaceObject);
const index_js_namespaceObject = require("../../constants/index.js");
const otpDeliveryChoiceChips = [
    {
        name: 'Phone (SMS)',
        size: 'medium',
        variation: 'subtle',
        deliveryMechanism: index_js_namespaceObject.otpDeliveryMechanisms.SMS,
        styling: {
            mr: 2
        }
    },
    {
        name: 'Email',
        size: 'medium',
        variation: 'subtle',
        deliveryMechanism: index_js_namespaceObject.otpDeliveryMechanisms.EMAIL_ONLY_OTP,
        styling: {}
    }
];
const FindMyTrips = ()=>{
    const messageEndRef = (0, external_react_namespaceObject.useRef)(null);
    const { setOtpDeliveryType, otpDeliveryType, otpDeliveryMethodUsed, setOtpFormData, showOtpVerificationForm } = (0, OtpContext_js_namespaceObject.useOtpContext)();
    const deliveryDestination = otpDeliveryMethodUsed === index_js_namespaceObject.otpDeliveryMechanisms.SMS ? 'phone number' : 'email address';
    (0, external_react_namespaceObject.useEffect)(()=>{
        setOtpFormData(void 0);
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        messageEndRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    }, [
        showOtpVerificationForm
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                mb: 4,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
                    ml: "",
                    mb: "20px",
                    variation: 'initial',
                    Icon: external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
                    message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                mb: 3,
                                children: "To help with your trip, just confirm the details linked to your booking. We'll send a quick verification code so we can unlock your itinerary."
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                                mb: 3,
                                children: "Choose how you'd like to receive it:"
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                                mb: 3,
                                children: otpDeliveryChoiceChips.map((choiceChip)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                                        size: choiceChip.size,
                                        variation: choiceChip.variation,
                                        ...choiceChip.styling,
                                        onClick: ()=>setOtpDeliveryType(choiceChip.deliveryMechanism),
                                        children: choiceChip.name
                                    }))
                            }),
                            showOtpVerificationForm ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                                fontWeight: 'bold',
                                children: [
                                    "We've sent a verification code to the ",
                                    deliveryDestination,
                                    " provided."
                                ]
                            }) : otpDeliveryType ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(OtpForm_js_default(), {}) : null
                        ]
                    }),
                    footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooter_js_default(), {})
                })
            }),
            showOtpVerificationForm ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
                mb: 4,
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.ChatMessage, {
                    ml: "",
                    mb: "20px",
                    variation: 'initial',
                    Icon: external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
                    message: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                                mb: 3,
                                children: [
                                    "Please enter the code sent to the ",
                                    deliveryDestination,
                                    " provided. "
                                ]
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(VerificationCode_js_default(), {})
                        ]
                    }),
                    footer: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MessageFooter_js_default(), {})
                })
            }) : null,
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ErrorComponent_js_default(), {}),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                ref: messageEndRef
            })
        ]
    });
};
const FindMyTrips_FindMyTrips = FindMyTrips;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
